import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-checkboxes', {
    mixins: [FormElementMixin],
    props: {
        selectOptions: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selected: this.value ? [ ...this.value ] : []
        }
    },
    watch: {
        selected() {
            this.currentValue = this.selected;
        }
    },
}, 'form/controls/ak-checkboxes.html');